export enum Controls {
    UNDO = 'UndoVariables',
    REDO = 'RedoVariables'
}
